import { api } from "../api";

/**
 * devicefindAllAllResponse - Function that finds on database all devices as list response data    
 * /devices/{managerId}/{status}/list  
 * method GET 
 * @async-function
 */
const devicefindAllListResponse = async (token: string, managerId: number, status: string) => {
    const response = await api.get(
        `/devices/${managerId}/${status}/list`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default devicefindAllListResponse;